var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found__content"},[_c('p',{staticClass:"not-found__txt"},[_vm._v("404")]),_c('p',{staticClass:"not-found__des"},[_vm._v("Page is not exist")])])])
}]

export { render, staticRenderFns }